define(function(require){
 	'use strict';

 	var Marionette = require('marionette');
 	var template   = require('text!modals/_base/template/header.tpl').default;

 	return Marionette.ItemView.extend({
 		template : template,
 		initialize : function(options){
            this.model = options;
 		}
 	});

 });
